import { useParams, Link } from 'react-router';
import { getBlogPostBySlug } from '../../lib/blogs.js';
import ArticleRenderer from '../../components/markdown/ArticleRenderer.jsx';
import { useDocumentTitle } from '../../lib/useDocumentTitle.js';

export default function BlogPost() {
  const { slug } = useParams();
  const post = getBlogPostBySlug(slug);
  useDocumentTitle(post ? post.title : 'Post Not Found');

  if (!post) {
    return (
      <div className="container" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
        <h1>Post not found</h1>
        <p>
          <Link to="/blog">Back to the blog</Link>
        </p>
      </div>
    );
  }

  return (
    <div className="container" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
      <p className="meta">
        <Link to="/blog">← Blog</Link>
      </p>
      <ArticleRenderer post={post} />
    </div>
  );
}
